exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2YQZX{position:relative;font-weight:400}._35LRr{width:100%}._35LRr img{width:inherit}._3wLwB{max-width:450px;margin:0 auto;padding:60px 20px}.Sq8Go{font-size:16px}.rgyhD{font-weight:400;padding:10px 0;text-align:right}._2bIPi{width:100%}._2bIPi img{width:70px;margin:0 auto;display:block}._2oSEE{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:60px 0}._1_7DV,._3Cy9Y{width:40%}._2Cw_x{font-weight:700;font-size:20px}._3RnPs{font-size:14px}._3Cy9Y img{width:100%}@media (max-width:767px){._2oSEE{-ms-flex-wrap:wrap;flex-wrap:wrap;padding:60px 40px}._1_7DV,._3Cy9Y{width:100%}}._3nEwt{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:60px 0}._3E_aX{width:30%;margin:5px;padding:20px;border:2px solid}.jHxAi{border-color:#e5a826}.jHxAi ._32nsB{color:#e5a826}._2KeCR{border-color:#dcefed}._2KeCR ._32nsB{color:#dcefed}._1yIbs{border-color:#daecc6}._1yIbs ._32nsB{color:#daecc6}._32nsB{font-weight:700;text-align:center;height:130px;font-size:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.YzmHU{padding-top:20px}@media (max-width:767px){._3nEwt{-ms-flex-wrap:wrap;flex-wrap:wrap;padding-bottom:0}._3E_aX{width:100%;margin:5px 20px}._32nsB{width:100%;display:block;height:inherit}}", ""]);

// exports
exports.locals = {
	"rowContainer": "_2YQZX",
	"headerImage": "_35LRr",
	"quoteContainer": "_3wLwB",
	"quoteText": "Sq8Go",
	"quoteName": "rgyhD",
	"dividerWrapper": "_2bIPi",
	"whyWrapper": "_2oSEE",
	"whyText": "_1_7DV",
	"whyPicture": "_3Cy9Y",
	"whyTitle": "_2Cw_x",
	"whyBody": "_3RnPs",
	"cardsContainer": "_3nEwt",
	"card": "_3E_aX",
	"cardOne": "jHxAi",
	"cardTitle": "_32nsB",
	"cardTwo": "_2KeCR",
	"cardThree": "_1yIbs",
	"cardBody": "YzmHU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/about/About.css
// module id = 1329
// module chunks = 13